/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useCallback, useState, useRef } from 'react'
import {
	Image,
	VStack,
	Center,
	useDisclosure,
	Collapse,
	Icon,
	Popover,
	HStack,
	PopoverTrigger,
	PopoverContent,
	PopoverBody,
	Input,
	Divider,
	Flex,
	Text,
	IconButton,
	Button,
	Box,
	Heading,
	Tooltip,
	Skeleton,
} from '@chakra-ui/react'
import { useAuthContext } from '../../../../context/auth.context'
import { useSharedContext } from '../../../../context/shared.context'
import { usePubNub } from 'pubnub-react'
import Card from '../../../card'

import {
	MdSend,
	MdArrowBack,
	MdInfo,
	MdModeEdit,
	MdCheckCircle,
	MdMoreVert,
	MdMoreHoriz,
	MdClose,
} from 'react-icons/md'
import { CHAT_PANEL_VIEW } from '../indes'
import SingleMessage from '../SingleMessage'
import profile from '../../../../assets/images/profile.png'
import group from '../../../../assets/images/group_icon.png'
import {
	useLoadGroupParticipants,
	useAlterFileCover,
	useAddTimelineUpdate,
	useRemoveParticipant,
	useInviteParticipant,
} from '../../../../hooks/activity.hooks'
import {
	formatDueDateForTimelineCurrDate,
	formatNoteUpdateDate,
	formatDDMMYYYY,
	getLeaveTimeDate,
} from '../../../../utils/date.utils'
import GroupList from '../GroupList'
import { sharedConst } from '../../../../utils/action.constant'
import { LoadChatData } from '../../../../hooks/asset.hooks'
import {
	getCurrentDateUTC,
	getMessageUniqueId,
} from '../../../../utils/common.util'
import {
	dataLayerTagManager,
	sectionDetailedTrack,
} from '../../../../containers/repository/repo.utils'
import { GA_CATEGORY_NAVBAR } from './../../../../containers/repository/repo.utils'
import { useLanguageContext } from '../../../../context/locale.context'
import bgImage from '../../../../assets/images/opaque_bgImage.png'
import { getFromNow, formatChatGroupBy } from '../../../../utils/date.utils'
import InputText from '../../../globalComponents/inputText'
import ButtonCTA from '../../../globalComponents/button'
import { ImAttachment } from 'react-icons/im'
import { pushFileToS3, loadAwsFile } from '../../../../utils/aws.util'
import { BsX } from 'react-icons/bs'
import { useDeepStreamContext } from '../../../../context/deepstream.context'
import CustomMenu from '../../../menu'
import { useSetState } from 'react-use'

export const GROUP_PANEL_VIEW = {
	GROUP_CHAT_VIEW: 'GROUP_CHAT_VIEW',
	GROUP_INFO_VIEW: 'GROUP_INFO_VIEW',
}

const ChatView = ({
	setchatView,
	user,
	chatData,
	onMessageSubmit,
	setisNewChat,
	isNewChat,
	onProfileSelection,
	setchatData,
	setselectedProfile,
	selectedProfile,
	isChatLoading,
}) => {
	const [chanelName, setchanelName] = useState('')
	const [userName, setUserName] = useState('')
	const [message, setmessage] = useState('')
	const [onlineStatus, setonlineStatus] = useState('')
	const messagesEndRef = useRef(null)
	const [groupView, setgroupView] = useState('')
	const [isGroupEdit, setisGroupEdit] = useState(false)
	const [groupName, setGroupName] = useState('')
	const [profileImageData, setProfileImageData] = useState('')
	const { isOpen, onToggle } = useDisclosure()
	const [attachmentURl, setattachmentURl] = useState('')
	const [isopens, setIsopens] = useState(true)
	const [groupCreatedDatetime, setGroupCreatedDatetime] = useSetState('')
	const {
		state: { authData },
	} = useAuthContext()
	const {
		state: { locale },
	} = useLanguageContext()
	const {
		state: { ds },
	} = useDeepStreamContext()
	const { mutate: inviteMutate } = useInviteParticipant()
	const { mutate: mutateFileEditSave, isLoading: isActivityUpdating } =
		useAlterFileCover()
	const { mutate: mutateaddTimeLineUpdate } = useAddTimelineUpdate()
	const { mutate: loadChatData } = LoadChatData()
	const { mutate: removeMutate } = useRemoveParticipant()
	const { state, dispatch } = useSharedContext()
	const { isRefreshChat, chatSelectedProfile } = state || {}
	const inputRef = useRef()
	const pubnub = usePubNub()
	const goBack = () => {
		if (groupView === GROUP_PANEL_VIEW.GROUP_INFO_VIEW) {
			setgroupView('')
			setisGroupEdit(false)
		} else {
			setchatView(CHAT_PANEL_VIEW.LIST_VIEW)
			setchatData([])
		}
	}

	useEffect(() => {
		onProfileSelection(chatSelectedProfile)
	}, [isRefreshChat])

	useEffect(() => {
		if (groupView === GROUP_PANEL_VIEW.GROUP_INFO_VIEW) {
			setgroupView('')
			setisGroupEdit(false)
		}
		toGetChatTitle()
		if (
			!!ds &&
			Object.keys(chatSelectedProfile).length > 0 &&
			!chatSelectedProfile?.isGroupChat
		) {
			if (!!ds && chatSelectedProfile?.activity_type_category_id !== 27)
				toShowStatus()
		}
	}, [chatSelectedProfile, ds])

	useEffect(() => {
		messagesEndRef.current?.scrollIntoView()
	}, [chatData, groupView])

	const toShowStatus = () => {
		let ChannelName = ''
		let hereNowUserId = 0
		if (chatSelectedProfile) {
			if (chatSelectedProfile.hasOwnProperty('activity_id')) {
				hereNowUserId = chatSelectedProfile.activity_lead_asset_id
			} else if (chatSelectedProfile.isGroupChat) {
				hereNowUserId = chatSelectedProfile.groupName
			} else {
				hereNowUserId = chatSelectedProfile.value?.contact_asset_id
			}

			ChannelName =
				user.asset_id > chatSelectedProfile.asset_id
					? chatSelectedProfile.asset_id + '-' + user.asset_id
					: user.asset_id + '-' + chatSelectedProfile.asset_id
			if (chatSelectedProfile.hasOwnProperty('activity_id')) {
				ChannelName = chatSelectedProfile.activity_title
			} else {
				ChannelName =
					user.asset_id > chatSelectedProfile.asset_id
						? chatSelectedProfile.asset_id + '-' + user.asset_id
						: user.asset_id + '-' + chatSelectedProfile.asset_id
			}
		}
		console.log({ ChannelName })
		if (!!ChannelName && ds) {
			ds.event.subscribe(ChannelName, data => {})
		}
		pubnub.subscribe({
			channels: [ChannelName],
			withPresence: true,
		})

		const UserID = hereNowUserId
		if (chatSelectedProfile) {
			// pubnub.getPresence(ChannelName, presence => {
			//   const TypingUser = presence.uuid.split('-')
			//   if (
			//     Number(TypingUser[0]) !== Number(user.asset_id) &&
			//     presence.action === 'state-change'
			//   ) {
			//     // this.setState({
			//     //     ...this.state,
			//     //     userIsTyping: presence.state.isTyping,
			//     // });
			//   }
			// })
			pubnub.whereNow(
				{
					uuid: UserID + '-' + user.organization_id,
				},
				(status, response) => {
					if (
						!!response &&
						!!response.channels &&
						response.channels.length > 0
					) {
						setonlineStatus('Online')
					} else {
						setonlineStatus('Offline')
					}
				}
			)
		}
	}

	const toGetChatTitle = () => {
		let userName = user.operating_asset_first_name
		if (
			chatSelectedProfile &&
			chatSelectedProfile.activity_title &&
			!isNewChat
		) {
			let activityTitle = chatSelectedProfile.activity_title.split('-')
			if (user.asset_id === chatSelectedProfile.activity_creator_asset_id) {
				userName = activityTitle[1]
			} else {
				userName = activityTitle[0]
			}
			if (chatSelectedProfile.activity_type_category_id === 27) {
				userName = chatSelectedProfile.activity_title
			}
		}
		let title
		title =
			isNewChat && chatSelectedProfile && chatSelectedProfile.isGroupChat
				? chatSelectedProfile.groupName
				: isNewChat
				? `${userName} - ${
						chatSelectedProfile &&
						chatSelectedProfile.operating_asset_first_name
							? chatSelectedProfile.operating_asset_first_name
							: ''
				  }`
				: chatSelectedProfile && chatSelectedProfile.activity_title
		if (
			chatSelectedProfile.activity_type_category_id === 16 ||
			chatSelectedProfile.activity_type_category_id === 27
		) {
			title = chatSelectedProfile.activity_title
		}
		setchanelName(title)
		setUserName(userName)
	}

	const groupInfo = () => {
		setgroupView(GROUP_PANEL_VIEW.GROUP_INFO_VIEW)
		setGroupName(chanelName)
	}

	// downloadAwsFile('https://worlddesk-staging-j21qqcnj.s3.ap-south-1.amazonaws.com/868/1102/5918/39749/2022/11/103/397491669632745361/Screenshot-from-2022-08-25-16-26-28.png')
	const onKeyDown = event => {
		// 'keypress' event misbehaves on mobile so we track 'Enter' key via 'keydown' event
		if (event.key === 'Enter') {
			event.preventDefault()
			event.stopPropagation()
			onMessageSubmit({
				message,
				user: chatSelectedProfile,
				url: attachmentURl,
			})
			setmessage('')
			setattachmentURl('')
		}
	}

	const buildTitleUpdateParams = updatedTitle => {
		const {
			activity_title,
			activity_datetime_end_deferred,
			activity_id,
			activity_type_id,
		} = chatSelectedProfile
		const coverPayload = {
			title: {
				old: activity_title,
				new: updatedTitle,
			},
			description: { old: '', new: '' },
			duedate: {
				old: activity_datetime_end_deferred,
				new: activity_datetime_end_deferred,
			},
		}
		return {
			activity_id: activity_id,
			activity_cover_data: JSON.stringify(coverPayload),
			activity_type_id: activity_type_id,
		}
	}

	const buildTimelineEntryParams = updatedTitle => {
		const {
			activity_title,
			activity_id,
			activity_type_category_id,
			parent_activity_id,
			activity_type_id,
		} = chatSelectedProfile
		const { operating_asset_first_name } = authData
		let activityTimelineJson = {
			content: `Activity title changed from "${
				activity_title ? activity_title : chanelName
			}" to "${updatedTitle}" by ${operating_asset_first_name} @
                ${formatDueDateForTimelineCurrDate()}`,
			subject: 'Note - ' + formatNoteUpdateDate(),
			mail_body: `Activity title changed from "${
				activity_title ? activity_title : chanelName
			}" to "${updatedTitle}" by ${operating_asset_first_name} @
                ${formatDueDateForTimelineCurrDate()}`,
			attachments: [],
			activity_reference: [
				{
					activity_title: '',
					activity_id: '',
				},
			],
			asset_reference: [],
			form_approval_field_reference: [],
		}
		return {
			activity_id: activity_id,
			activity_type_category_id: activity_type_category_id,
			activity_type_id: activity_type_id,
			activity_parent_id: parent_activity_id,
			activity_timeline_collection: JSON.stringify(activityTimelineJson),
			activity_stream_type_id: 711,
			timeline_stream_type_id: 711,
			// data_entity_inline: JSON.stringify(activityTimelineJson),
			operating_asset_first_name: operating_asset_first_name,
		}
	}

	//change group name:---
	const onRenameActivity = activityName => {
		if (!activityName) return
		let activity = chatSelectedProfile
		const { activity_title } = chatSelectedProfile
		if (activity_title !== activityName) {
			let titleParams = buildTitleUpdateParams(activityName)
			let timelineParams = buildTimelineEntryParams(activityName)
			mutateFileEditSave(
				{ activity, ...titleParams },
				{
					onSuccess: async () => {
						loadChatData(
							{
								asset_message_counter: 0,
								message_unique_id: 1636353695988,
								track_latitude: 0,
								track_longitude: 0,
								track_altitude: 0,
								track_gps_datetime: getCurrentDateUTC(new Date()),
								track_gps_accuracy: 0,
								track_gps_status: 0,
								page_limit: 50,
								page_start: 0,
							},
							{
								onSuccess: async data => {
									setisGroupEdit(false)
									let selectdValue = data.find(
										val => val.activity_id === chatSelectedProfile.activity_id
									)
									onProfileSelection(selectdValue)
								},
								onError: async err => {
									console.log(err)
								},
							}
						)
						mutateaddTimeLineUpdate(
							{ ...timelineParams },

							{
								onSuccess: async () => {
									dispatch({
										type: sharedConst.REFRESH_CHAT_COUNT,
										isRefreshChat: false,
									})
								},
							}
						)
					},
				}
			)
		}
		setisGroupEdit(false)
	}

	// const removeParticipant = useCallback(participant => {
	// 	const { activity_id } = chatSelectedProfile
	// 	removeMutate(
	// 		{
	// 			activity_id,
	// 			activity_participant_collection: JSON.stringify([
	// 				{
	// 					...participant,
	// 					access_role_id: 0,
	// 					message_unique_id: getMessageUniqueId(),
	// 				},
	// 			]),
	// 		},
	// 		{
	// 			onSuccess: async data => {
	// 				groupInfo()
	// 			},
	// 			onError: async error => {
	// 				console.log('remove error', error)
	// 			},
	// 		}
	// 	)
	// })

	// const inviteUser = useCallback(
	// 	({
	// 		// contact_asset_type_id,
	// 		// contact_asset_id,
	// 		// contact_first_name,
	// 		// contact_operating_asset_name,
	// 		asset_type_id,
	// 		asset_id,
	// 		asset_first_name,
	// 		operating_asset_first_name,
	// 		workforce_name,
	// 	}) => {
	// 		const { activity_id, activity_type_id } = chatSelectedProfile
	// 		inviteMutate(
	// 			{
	// 				activity_id,
	// 				activity_type_category_id: 27,
	// 				activity_type_id,
	// 				contact: {
	// 					asset_type_id: asset_type_id,
	// 					asset_id: asset_id,
	// 					asset_first_name: asset_first_name,
	// 					operating_asset_first_name: operating_asset_first_name,
	// 					workforce_name,
	// 				},
	// 			},
	// 			{
	// 				onSuccess: async data => {
	// 					groupInfo()
	// 				},
	// 			}
	// 		)
	// 	}
	// )
	// let profileIcon = ''
	// if (selectedProfile?.activity_lead_asset_image_path) {
	//   loadAwsFile(selectedProfile?.activity_lead_asset_image_path, d => {
	//     profileIcon = 'data:' + d.type + ';base64,' + d.data
	//     console.log(
	//       selectedProfile?.activity_lead_asset_image_path,
	//       profileIcon,
	//       'ss1'
	//     )
	//   })
	// }
	useEffect(() => {
		setTimeout(() => {
			if (!!selectedProfile?.activity_lead_asset_image_path) {
				loadAwsFile(selectedProfile?.activity_lead_asset_image_path, d => {
					let imagedata = 'data:' + d.type + ';base64,' + d.data
					setProfileImageData(imagedata)
				})
			}
		}, 1000)
	}, [selectedProfile?.activity_lead_asset_image_path])
	const profileImage = selectedProfile?.activity_lead_asset_image_path
		? profileImageData
		: profile
	// const openCloseClick = () => {
	//   onToggle()
	// }

	const onHandleFileChange = async event => {
		const file = event.target['files'][0]
		const blob = file?.slice(0, file.size, file.type)
		const newFile = new File([blob], file.name.replace(/ /gi, '-'), {
			type: blob.type,
		})
		let result = await pushFileToS3(newFile)
		const [{ url }] = await Promise.all([result])

		setattachmentURl(url)
		setmessage(toReturnName(url))
	}

	const clearFiles = () => {
		setattachmentURl('')
		setmessage('')
	}

	const toReturnName = url => {
		return url?.split('/').pop()
	}
	const onClickGrouoInfo = () => {
		setIsopens(true)
		sectionDetailedTrack({
			category: GA_CATEGORY_NAVBAR,
			action: 'Chat View',
			label: 'Group Info View',
		})
		dataLayerTagManager('button_click', {
			viewName: 'Chat',
			buttonName: 'Group Info',
		})
		groupInfo()
	}
	const EditFun = () => {
		setisGroupEdit(true)
	}
	const saveGroupName = () => {
		sectionDetailedTrack({
			category: GA_CATEGORY_NAVBAR,
			action: 'Chat View',
			label: 'Rename',
		})
		onRenameActivity(groupName)
	}
	const { isOpens, onOpen, onClose } = useDisclosure()
	let cdt = getLeaveTimeDate(chatSelectedProfile?.activity_datetime_created)
	return (
		<>
			{isChatLoading ? (
				[1, 2, 3, 4, 5, 6, 7, 8].map(i => {
					return (
						<Skeleton
							boxShadow='md'
							borderRadius='md'
							key={i}
							mb={2}
							w='full'
							h='53px'
						/>
					)
				})
			) : (
				<>
					<Flex alignItems='center' justifyContent='space-between' bg='#FFFFFF'>
						<Flex alignItems='center'>
							{/* <IconButton
              aria-label="Call Segun"
              size="sm"
              icon={<MdArrowBack />}
              onClick={() => {
                sectionDetailedTrack({
                  category: GA_CATEGORY_NAVBAR,
                  action: 'Chat View',
                  label: 'Go Back',
                })
                goBack()
              }}
            /> */}
							{chanelName ? (
								chatSelectedProfile.activity_type_category_id === 27 ||
								chatSelectedProfile.isGroupChat ? (
									<Image
										src={group}
										h='48px'
										w='48px'
										borderRadius='50%'
										ml='2'
									/>
								) : (
									<Image
										src={profileImage}
										h='48px'
										w='48px'
										borderRadius='50%'
										ml='2'
										mb='1'
									/>
								)
							) : (
								''
							)}
							<VStack
								alignItems='flex-start'
								marginLeft='10px'
								lineHeight='15px'
							>
								{groupView === GROUP_PANEL_VIEW.GROUP_INFO_VIEW ? (
									<Flex alignItems='center'>
										{!isGroupEdit ? (
											<React.Fragment>
												{/* <Text
											fontSize='24px'
											alignSelf='flex-end'
											fontWeight='bold'
											marginLeft='4'
										>
											{userName}
										</Text> */}
												{/* <Text marginLeft="4" color="#2D3748">
                    </Text> */}
												{/* {user.operating_asset_first_name ===
											groupUsers?.[0]
												?.activity_creator_operating_asset_first_name && (
											<Text
												marginLeft='2'
												cursor='pointer'
												padding='2'
												onClick={() => {
													sectionDetailedTrack({
														category: GA_CATEGORY_NAVBAR,
														action: 'Chat View',
														label: 'Group Edit',
													})
													dataLayerTagManager('button_click', {
														viewName: 'Chat',
														buttonName: 'Group Name Edit',
													})
													setisGroupEdit(true)
												}}
											>
												<MdModeEdit color='teal' size={16} />
											</Text>
										)} */}
											</React.Fragment>
										) : (
											// <React.Fragment>
											// 	<Input
											// 		marginLeft='2'
											// 		size='sm'
											// 		placeholder='Enter Group Name'
											// 		value={groupName}
											// 		onChange={e => setGroupName(e.target.value)}
											// 	/>
											// 	<Text
											// 		marginLeft='2'
											// 		cursor='pointer'
											// 		padding='2'
											// 		onClick={() => {
											// 			sectionDetailedTrack({
											// 				category: GA_CATEGORY_NAVBAR,
											// 				action: 'Chat View',
											// 				label: 'Rename',
											// 			})
											// 			onRenameActivity(groupName)
											// 		}}
											// 	>
											// 		<MdCheckCircle color='teal' />
											// 	</Text>
											// </React.Fragment>
											''
										)}
									</Flex>
								) : (
									''
								)}
								<Text
									color='#131D0B'
									fontSize='16px'
									fontStyle='normal'
									fontWeight='500'
								>
									{chanelName ? userName : ''}
								</Text>
								{chatSelectedProfile.activity_type_category_id !== 27 &&
								!chatSelectedProfile.isGroupChat &&
								chanelName ? (
									<Text
										fontSize='14px'
										fontWeight='400'
										pb='2'
										color={onlineStatus === 'Online' ? 'green.500' : ''}
									>
										{onlineStatus}
									</Text>
								) : null}
							</VStack>
						</Flex>
						{/* {chatSelectedProfile.activity_type_category_id === 27 ||
        chatSelectedProfile.isGroupChat
          ? groupView !== GROUP_PANEL_VIEW.GROUP_INFO_VIEW && (
              <Button
                size="sm"
                marginRight="7"
                as={Button}
                colorScheme="green"
                rightIcon={<MdInfo fontSize="20px" />}
                onClick={() => {
                  sectionDetailedTrack({
                    category: GA_CATEGORY_NAVBAR,
                    action: 'Chat View',
                    label: 'Group Info View',
                  })
                  dataLayerTagManager('button_click', {
                    viewName: 'Chat',
                    buttonName: 'Group Info',
                  })
                  groupInfo()
                }}
              >
                {locale['Info']}
              </Button>
            )
          : null} */}
						{chanelName ? (
							// <Flex cursor="pointer" onClick={openCloseClick} alignItems="center">
							<Flex cursor='pointer' alignItems='center'>
								<CustomMenu
									className={`timeline-attachment-message-menu`}
									icon={MdMoreHoriz}
									color='brand.700'
									border=' 1px solid #D9D9D9'
									borderRadius='50%'
									textAlign='center'
									paddingBottom='6px'
									fontWeight='900'
									top='0px'
									right='5px'
									optionList={[
										{
											label: locale['Group Info'],
											isMenu: true,
											optionListProps: { color: 'brand.700' },
											disabled:
												chatSelectedProfile.activity_type_category_id === 27 ||
												chatSelectedProfile.isGroupChat
													? false
													: true,
											onClick: e => {
												onClickGrouoInfo()
											},
										},
										// {
										// 	label: locale['Search'],
										// 	isMenu: true,
										// 	disabled: false,
										// 	optionListProps: { color: 'brand.700' },
										// },
										// {
										// 	label: locale['Media'],
										// 	isMenu: true,
										// 	disabled: false,
										// 	optionListProps: { color: 'brand.700' },
										// },
									]}
								/>

								{/* <ButtonCTA
              children={'...'}
              color="brand.700"
              border=" 1px solid #D9D9D9"
              borderRadius="50%"
              textAlign="center"
              paddingBottom="6px"
              fontWeight="900"
              w="40px"
              h="40px"
            /> */}

								{/* <Collapse
              in={isOpen}
              style={{ position: 'absolute', right: '1%', top: '1.8%' }}
            >
              <Box
                boxShadow=" 0px 2px 10px rgba(0, 0, 0, 0.1)"
                sx={{ zIndex: '999', position: 'relative' }}
                mt="70"
                bg="#FFFFFF"
                h="120px"
                w="200px"
                borderRadius="10px"
              >
                <IconButton
                  w="32px"
                  h="34px"
                  borderRadius="50%"
                  border="1px solid #D9D9D9"
                  color="#E74C3C"
                  variant=""
                  icon={<MdClose />}
                  alignItems="center"
                  mt="5px"
                  ml="75%"
                  onClick={openCloseClick}
                />
                <Text color="brand.700" lineHeight="40px" pl="20px">
                  Search
                </Text>
                <Text color="brand.700" pl="20px">
                  Media,links and files
                </Text>
              </Box>
            </Collapse> */}
							</Flex>
						) : (
							''
						)}
					</Flex>

					<Divider />

					{groupView === GROUP_PANEL_VIEW.GROUP_INFO_VIEW ? (
						<GroupList
							// groupUsers={groupUsers}
							// removeParticipant={removeParticipant}
							// inviteUser={inviteUser}
							user={user}
							groupImage={group}
							chanelName={chanelName}
							isopens={isopens}
							setIsopens={setIsopens}
							setgroupView={setgroupView}
							groupCreatedDatetime={cdt}
							EditFun={EditFun}
							saveGroupName={saveGroupName}
							isGroupEdit={isGroupEdit}
							setisGroupEdit={setisGroupEdit}
							groupName={groupName}
							setGroupName={setGroupName}
						/>
					) : (
						<>
							<Box
								overflowY='auto'
								overflowX='hidden'
								backgroundRepeat='no-repeat'
								backgroundPosition='center'
								backgroundSize='cover'
								position='relative'
								backgroundImage={`url(${bgImage})`}
								backgroundColor='#bbbbbb1a'
								borderLeft='0.5px solid #e0e0e0'
								flexGrow='1'
								sx={{
									'&::-webkit-scrollbar': {
										width: '8px',
										//backgroundColor: `rgb(0,155,118)`,
									},
									'&::-webkit-scrollbar-thumb': {
										backgroundColor: `rgb(0,155,118)`,
									},
									'&::-webkit-scrollbar-button': {
										height: '20px',
									},
								}}
							>
								{chatData?.length > 0 &&
									chatData?.map((item, i, array) => {
										let msgDate = formatDDMMYYYY(item.datetime_log)

										let size = 3
										let showTag = true
										if (i === 0) {
											size = 3
										} else {
											let lastDate = formatDDMMYYYY(array[i - 1]?.datetime_log)
											if (msgDate === lastDate) {
												showTag = false
											} else {
												showTag = true
											}
											size =
												typeof item?.data_entity_inline === 'string'
													? item?.data_entity_inline.length
													: Object.keys(item?.data_entity_inline).length
										}

										return (
											<React.Fragment key={i}>
												{showTag && size > 2 ? (
													<Center>
														<Box
															bg='#F8FAFC'
															width='100px'
															height='30px'
															color='gray.400'
															padding='5px'
															mt='5px'
															mb='5px'
															fontSize='14px'
															fontWeight='400'
															borderRadius='55px'
															textAlign='center'
														>
															{formatChatGroupBy(item.datetime_log)}
														</Box>
													</Center>
												) : (
													''
												)}
												<SingleMessage
													// key={i + 1}
													index={i}
													messages={item}
													user={user}
													chanelName={userName}
													profileImage={profileImage}
												/>
												<div ref={messagesEndRef} />
											</React.Fragment>
										)
									})}
							</Box>
							<Divider />
							{chanelName ? (
								<Box
									display='flex'
									justifyContent='space-between'
									alignItems='center'
								>
									{attachmentURl ? (
										<Card boxShadow='md' borderRadius='md' maxW='300px'>
											<Flex spacing='4'>
												<Flex
													flex='1'
													gap='4'
													alignItems='center'
													flexWrap='wrap'
												>
													<Heading size='sm'>
														{toReturnName(attachmentURl)}
													</Heading>
												</Flex>
												<IconButton
													variant='ghost'
													colorScheme='gray'
													aria-label='See menu'
													cursor='pointer'
													size='md'
													onClick={clearFiles}
													icon={<BsX size='27' />}
												/>
											</Flex>
										</Card>
									) : (
										<InputText
											placeholder={locale['Write a message'] + '...'}
											_placeholder={{
												color: '#969696',
											}}
											value={message}
											onKeyDown={onKeyDown}
											onChange={e => setmessage(e.target.value)}
											border='none'
										/>
									)}
									{/* <Flex pt="5px"> */}
									<Popover
										styleConfig={{
											// maxWidth: '100px',
											// width: '100px',
											borderRadius: '5px',
										}}
									>
										<HStack marginLeft='auto'>
											<PopoverTrigger>
												<IconButton
													w='50px'
													h='45px'
													variant=''
													color='brand.700'
													aria-label='Search database'
													icon={<MdMoreVert />}
												/>
											</PopoverTrigger>
										</HStack>

										<PopoverContent>
											<PopoverBody
												bg='#FFFFFF'
												borderRadius='15px'
												h='70px'
												boxShadow='0px 6px 14px -6px rgba(24, 39, 75, 0.12), 0px 10px 32px -4px rgba(24, 39, 75, 0.1)'
											>
												<Tooltip hasArrow label={locale['File Upload']}>
													<IconButton
														bg=''
														mt='30%'
														color='brand.700'
														aria-label='Add participant'
														size='md'
														icon={<Icon as={ImAttachment} w={5} h={5} />}
														onClick={() => {
															inputRef.current.click()
														}}
													/>
												</Tooltip>
												<input
													type='file'
													// accept={acceptedFileTypes}
													name='file'
													onChange={onHandleFileChange}
													ref={inputRef}
													style={{ display: 'none' }}
												></input>
											</PopoverBody>
										</PopoverContent>
									</Popover>

									<IconButton
										alignItems='center'
										w='40px'
										h='40px'
										borderRadius='50%'
										bg='brand.700'
										color='#FFFFFF'
										variant=''
										aria-label='Search database'
										icon={<MdSend />}
										onClick={() => {
											sectionDetailedTrack({
												category: GA_CATEGORY_NAVBAR,
												action: 'Chat View',
												label: 'Message Submit',
											})
											dataLayerTagManager('button_click', {
												viewName: 'Chat',
												buttonName: 'Send Message',
											})
											onMessageSubmit({
												message,
												user: chatSelectedProfile,
												url: attachmentURl,
											})
											setmessage('')
											setattachmentURl('')
										}}
									/>
									{/* </Flex> */}
								</Box>
							) : (
								''
							)}
						</>
					)}
				</>
			)}
		</>
	)
}

export default ChatView
